import { call, delay, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { VasRuleActionTypes, VasRuleActions } from "../../../actionTypes/master/vasRuleActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  getVasRuleList,
  setVasRuleDataById,
  setVasRuleList,
  setVasRuleListPageCount,
} from "../../../actions/master/vasRuleActions";
import {
  createVasRuleApi,
  editVasRuleDataByIdApi,
  getVasRuleDataByIdApi,
  getVasRuleListApi,
} from "../../requests/master/vasRuleRequests";


function* createVasRuleHandler(action: VasRuleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVasRuleApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(false));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasRuleListHandler(action: VasRuleActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVasRuleListApi, action.payload);

    if (data.status) {
      yield put(setVasRuleList(data?.data?.rows ?? []));
      yield put(setVasRuleListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasRuleDataByIdHandler(action: VasRuleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVasRuleDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVasRuleDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVasRuleDataByIdHandler(action: VasRuleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVasRuleDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVasRuleList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* vasRuleSaga() {
  yield takeLatest(VasRuleActions.CREATE_VAS_RULE, createVasRuleHandler);
  yield takeLatest(VasRuleActions.GET_VAS_RULE_LIST, getVasRuleListHandler);
  yield takeLatest(VasRuleActions.GET_VAS_RULE_DATA_BY_ID, getVasRuleDataByIdHandler);
  yield takeLatest(VasRuleActions.EDIT_VAS_RULE_DATA_BY_ID, editVasRuleDataByIdHandler);
}
